const getSupplierState = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Address'] && business['Company Address'].State) {
    return business['Company Address'].State;
  }
  return null;
};

export default getSupplierState;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierState.js